import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import { elementsInLoading, selectedCountryPricing, selectedMarketplacePricing, skuDetailsScores, skuDetailsScoresInLoading } from "../../@signals"


export default function useSkuDetailsStockData() {
	const { showToast } = useAppToast()

	const stockData = useSignal({})
    const isLoadingStock = useSignal(false)

    const retailersFilterData = useSignal([])
    const sellersFilterData = useSignal([])
    const selectedCountry = useSignal(null)
    const selectedMarketplace = useSignal(null)
   
    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			stockData.value = {}
            retailersFilterData.value = []
            sellersFilterData.value = []
            isLoadingStock.value = true
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/stock`, { ...commonFiltersValue.value }).then(res => {
				stockData.value = res
                skuDetailsScores.value["Stock"] = res.percentageScore
                skuDetailsScores.value["Assortment"] = res.assortmentScore

                if (res.country == []) {
                    selectedCountry.value = null
                    selectedMarketplace.value = null
                    retailersFilterData.value = []
                    sellersFilterData.value = []
                } else {
                    if (selectedCountry.value) {
                        retailersFilterData.value = Array.isArray(res.retailers) 
                            ? res.retailers.filter(row => row.country === selectedCountry.value)
                            : []
                    }
                    if (selectedMarketplace.value) {
                        sellersFilterData.value = Array.isArray(res.sellers) 
                            ? res.sellers.filter(row => row.siteID === selectedMarketplace.value)
                            : []
                    }
                }
			}).catch(() => showToast.error()
			).finally(() => {
                isLoadingStock.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	useEffect(() => {
		if (isLoadingStock.value){
			elementsInLoading.value = [...elementsInLoading.value, 'stock']
            skuDetailsScoresInLoading.value = [...skuDetailsScoresInLoading.value, "Stock"]
		} else {
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'stock')
            skuDetailsScoresInLoading.value = skuDetailsScoresInLoading.value.filter(item => item !== "Stock")
		}
	}, [isLoadingStock.value])

    useEffect(() => {
        selectedCountryPricing.value = selectedCountry.value
        selectedMarketplacePricing.value = selectedMarketplace.value
    }, [selectedCountry.value, selectedMarketplace.value])

    const handleClickMarket = (country) => {
        if (selectedCountry.value === country) {
            selectedCountry.value = null
            selectedMarketplace.value = null
            retailersFilterData.value = []
            sellersFilterData.value = []
        } else {
            selectedCountry.value = country
            selectedMarketplace.value = null
            sellersFilterData.value = []
            retailersFilterData.value = stockData.value.retailers.filter(row => row.country === country)
        }
    }

    const handleClickMarketplace = (siteID, isMarketplace) => {
        if (isMarketplace) {
            if (selectedMarketplace.value === siteID) {
                selectedMarketplace.value = null
                sellersFilterData.value = []
            } else {
                selectedMarketplace.value = siteID
                sellersFilterData.value = stockData.value.sellers.filter(row => row.siteID === siteID)
            }
        }
    }

	return {
		stockData: stockData.value,
        isLoadingStock: isLoadingStock.value,
        retailersFilterData: retailersFilterData.value,
        sellersFilterData: sellersFilterData.value,
        selectedCountry: selectedCountry.value,
        selectedMarketplace: selectedMarketplace.value,
        handleClickMarket,
        handleClickMarketplace
	}
}